import { render, staticRenderFns } from "./UnknowOrder.vue?vue&type=template&id=abf58b32&scoped=true&"
import script from "./UnknowOrder.vue?vue&type=script&lang=js&"
export * from "./UnknowOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf58b32",
  null
  
)

export default component.exports